/**虚拟课程模块 */
import request from '../request/http';
function queryId(){
    return sessionStorage.getItem('institutionTenantId')||'';
}
/**获取用户详情 */
export function VirtualCoursePageList(data){
    return request({
        url: '/sp/virtualCourse/virtualCoursePageList',
        method: 'post',
        data,
        headers:{
            'institutionTenantId':queryId()
        }
    })
}